import React from 'react';

import Img from '../../Img';
import Popup from '../../Popup/PopupV2';

import styles from './upgradeV2.scss';
import popupStyles from '../../Popup/popupv2.scss';

const SuccessPopupV2 = (props) => {
    const handleCloseClick = () => {
        props.onCloseClick();
    };

    const modalHeader = () => {
        return (
            <div className={`asdf ${popupStyles.modalHeader} ${styles.header}`}>
                <div className={styles.background}>
                    <Img src="/img/v3/graphics/modals/welcome-to-power-2x.png" />
                </div>
                <div
                    className={`${popupStyles.btnClose} ${styles.close}`}
                    onClick={handleCloseClick}
                    data-testid="upgrade-to-power.success.close-btn"
                >
                    <i className={`utr utr-close`} />
                </div>
            </div>
        );
    };

    return (
        <div className={styles.popup}>
            <Popup
                className="popup-md"
                config={{
                    size: 'md',
                    scrollable: true,
                    customHeader: modalHeader,
                    customWidth: '630px',
                }}
                onCloseClick={handleCloseClick}
            >
                <div className={`${styles.content} pb0`}>
                    <div className={styles.title} data-testid="upgrade-to-power.success.title">
                        Congratulations!
                    </div>
                    <div className={`${styles.subtitle} ${styles.success}`}>
                        You are now a Power user. Start enjoying your perks and benefits.
                    </div>
                    <div
                        className={`btn btn-primary btn-xl btn-block text-uppercase`}
                        onClick={handleCloseClick}
                        data-testid="upgrade-to-power.success.lets-get-started-btn"
                    >
                        Let&apos;s get started
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default SuccessPopupV2;
